import { render, staticRenderFns } from "./NavigationSection.vue?vue&type=template&id=2ee35364"
import script from "./NavigationSection.vue?vue&type=script&lang=js"
export * from "./NavigationSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports